import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { ResourcingCurrentDateLine } from '~/modules/resourcing/common/components';
import {
  itemWidth,
  actionsWidth
} from '~/modules/common/charts/timeline/calculations';
import ConditionalWrapper from '~/modules/common/components/ConditionalWrapper';
import { useMeContext } from '~/modules/me';
import { ResourceRequestToolbar } from '../components';
import {
  useResourcingChartToolbarContext,
  useSelectedResourceRequestContext
} from '../hooks';
import ResourceAllocationChart2 from '../ResourceRequestChart/ResourceAllocationChart2';
import ResourceRequestChart2 from '../ResourceRequestChart/ResourceRequestChart2';
import { ResourceRequestChartHeader } from '../ResourceRequestChart/components';
import ResourceRequestDrawer from '../ResourceRequestChart/components/ResourceRequestDrawer/ResourceRequestDrawer2';
import {
  AllocationChartContextProvider,
  ResourceAllocationChartFocusContextProvider
} from './contexts';

const LEFT_WIDTH = 464;
const FOOTER_HEIGHT = 40;

const leftComponentWidth = actionsWidth + itemWidth * 2;

const useStyles = makeStyles(() => ({
  container: {
    position: 'relative'
  }
}));

const DesktopResourcingPlanPage = ({
  isEditSwitchEnabled,
  openAddResourceRequestDialog
}) => {
  const {
    scale,
    chartDates,
    displayUnit,
    sort,
    onSortChange
  } = useResourcingChartToolbarContext();

  const classes = useStyles();
  const allocationChartRef = useRef();

  const {
    selectedResourceRequestId,
    closeResourceRequestDrawer,
    isResourceRequestDrawerOpen
  } = useSelectedResourceRequestContext();

  const {
    featureFlags: { isPsaRmpTaskAllocation1Enabled, isPsaRmp2025Q3WcagEnabled }
  } = useMeContext();

  return (
    <>
      <ResourceRequestToolbar />
      <div className={classes.container}>
        <ResourcingCurrentDateLine
          scale={scale}
          chartDates={chartDates}
          leftWidth={LEFT_WIDTH}
          footerHeight={FOOTER_HEIGHT}
        />
        <ResourceRequestChartHeader
          chartDates={chartDates}
          scale={scale}
          leftComponentWidth={leftComponentWidth}
          displayUnit={displayUnit}
          sort={sort}
          onSortChange={onSortChange}
        />
        <AllocationChartContextProvider allocationChartRef={allocationChartRef}>
          <ResourceRequestChart2
            handleAddResourceRequestClick={openAddResourceRequestDialog}
            allocationChartRef={allocationChartRef}
          />
          <ConditionalWrapper
            condition={
              isPsaRmpTaskAllocation1Enabled && isPsaRmp2025Q3WcagEnabled
            }
            WrapperComponent={ResourceAllocationChartFocusContextProvider}
          >
            <ResourceAllocationChart2 ref={allocationChartRef} />
          </ConditionalWrapper>
          {isResourceRequestDrawerOpen && (
            <ResourceRequestDrawer
              resourceRequestId={selectedResourceRequestId}
              allocationChartRef={allocationChartRef}
              onClose={closeResourceRequestDrawer}
              isEditSwitchEnabled={isEditSwitchEnabled}
              open={isResourceRequestDrawerOpen}
            />
          )}
        </AllocationChartContextProvider>
      </div>
    </>
  );
};

DesktopResourcingPlanPage.propTypes = {
  isEditSwitchEnabled: PropTypes.bool.isRequired,
  openAddResourceRequestDialog: PropTypes.func.isRequired
};

export default DesktopResourcingPlanPage;
